import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash'

export default {

    state: {
        restaurantGroups: [],
        promisesStatus: {}
    },

    mutations: {

        setRestaurantGroups(state, payload) {
            state.restaurantGroups = payload
        },

        addRestaurantGroup(state, payload) {
            state.restaurantGroups.unshift(payload)
        },

        editRestaurantGroup(state, payload) {
            const index = state.restaurantGroups.findIndex(
                item => item.id === payload.id
            )

            if (index !== -1) {
                Vue.set(state.restaurantGroups, index, payload)
            }
        },

        setPromiseStatus(state, { promiseName, status }) {
            state.promisesStatus[promiseName] = status
        }
    },

    actions: {

        //FETCH GROUPS
        async fetchRestaurantGroups({ commit, dispatch, state }) {

            let promiseName = `fetchRestaurantGroups`

            if (!state.promisesStatus[promiseName]) {


                commit('clearError')
                commit('setLoading', true)

                let user = JSON.parse(localStorage.getItem("user"))

                try {

                    let { data } = await axios.get(
                        `${this._vm.appConfig.app_url}/api/restaurant-groups`,
                        {
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                "Authorization": `Bearer ${user.access_token}`
                            }
                        }
                    )                    

                    commit('setLoading', false)
                    commit('setRestaurantGroups', data)
                    commit('setPromiseStatus', { promiseName, status: true })

                } catch (error) {

                    commit('setLoading', false)

                    if (error.response) {
                        let errors = error.response

                        if (errors.status == 401) {
                            dispatch('logOutUser')
                            window.location.reload()
                        }

                        if (errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0])
                            return Promise.reject(errors.data)
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message)
                    } else {
                        dispatch('setError', error)
                    }
                }
            }
        },
        //CREATE GROUP
        async createRestaurantGroup({ commit, dispatch }, payload) {

            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"))

            try {

                let { data } = await axios.post(
                    `${this._vm.appConfig.app_url}/api/restaurant-groups`,
                    payload,
                    {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    }
                )

                commit('setLoading', false)

                console.log(data);

                commit('addRestaurantGroup', data.data)

                return data.data

            } catch (error) {

                commit('setLoading', false)

                if (error.response) {

                    let errors = error.response

                    if (errors.status == 401) {
                        dispatch('logOutUser')
                        window.location.reload()
                    }

                    if (errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0])
                        return Promise.reject(errors.data)
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message)
                } else {
                    dispatch('setError', error)
                }

                throw error
            }
        },
        //UPDATE GROUP
        async updateRestaurantGroup({ commit, dispatch }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"))

            try {
                // PUT request to update
                let { data } = await axios.put(
                    `${this._vm.appConfig.app_url}/api/restaurant-groups/${payload.id}`,
                    {
                        name: payload.name,
                        area_id: payload.area_id,
                        restaurant_ids: payload.restaurant_ids,
                        waiting_lat: payload.waiting_lat,
                        waiting_lng: payload.waiting_lng,
                        status: (payload.status !== undefined && payload.status !== null) ? payload.status : true
                    },
                    {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Authorization': `Bearer ${user.access_token}`
                        }
                    }
                )

                commit('setLoading', false)

                // Update store
                commit('editRestaurantGroup', data.data)

                return data.data

            } catch (error) {
                commit('setLoading', false)

                if (error.response) {
                    const errors = error.response
                    if (errors.status === 401) {
                        dispatch('logOutUser')
                        window.location.reload()
                    }
                    if (errors.status === 400) {
                        dispatch('setError', _.values(errors.data)[0][0])
                        return Promise.reject(errors.data)
                    }
                }

                dispatch('setError', error.message || error)
                throw error
            }
        }
    },

    getters: {
        restaurantGroups(state) {
            return state.restaurantGroups
        }

    }
}
